import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tree-view" }

import InnerContainer from "@/views/grammar/newGrammar/components/InnerContainer.vue";
import MindTree from "@/views/grammar/newGrammar/components/MindTree.vue";
import { ref, computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Template5',
  props: {
  templateData: {
    type: Object,
  },
},
  setup(__props) {

const props = __props;

// 确保传递给MindTree的数据是稳定的
const stableContent = computed(() => {
  return props.templateData?.content || [];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnerContainer, {
    title: __props.templateData?.pageTitle,
    "sub-title": __props.templateData?.problem
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(MindTree, { "tree-data": stableContent.value }, null, 8, ["tree-data"])
      ])
    ]),
    _: 1
  }, 8, ["title", "sub-title"]))
}
}

})